import styled, { css } from "styled-components";

/**
 * Component Wrapper Element
 */
export var Wrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Dividerstyle__Wrapper"
})(_ref => {
  var { theme, orientation } = _ref;
  return css(
    ["background-color:", ";", ";"],
    theme.colors.black,
    orientation === "horizontal" ? css(["height:1px;width:100%;"]) : css(["height:100%;width:1px;"])
  );
});
